import axios from 'axios';
import { browserHistory } from 'react-router';

import {
  REQUEST_AUTH,
  AUTH_USER,
  AUTH_ERROR,
  UNAUTH_USER,
  AUTH_USER_PERMISSIONS,
  REQUEST_PERMISSIONS,
  FETCH_PERMISSION_SUCCESS,
  FETCH_PERMISSION_FAILURE,
} from './type';

import {
  TRUCKXI_LOGIN_URL,
  TRUCKXI_TEST_URL,
  PERMISSION_URL,
} from './url';

import checkPermission from '../components/Common/permissions';
import { ROOT_URL, ROOT_API_URL } from '../actions/root_url';
const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';
const isOCM = ROOT_API_URL === 'https://ocm-scm.truckxi.com/api/'|| ROOT_URL === 'https://ocm-scm.truckxi.com/api/';

import { DEFAULT_ERROR } from '../components/Common/constants';
// If successfully signed in or signed up, save the token, set state and
// navigate user to the 'User' page.

export function requestPermissions() {
  return {
    type: REQUEST_PERMISSIONS,
  };
}

export function fetchPermissionsSuccess(response) {
  localStorage.setItem('userPermissions', JSON.stringify(response.data.permissions));
  localStorage.setItem('companyCode', response.data.companyCode);
  return {
    type: FETCH_PERMISSION_SUCCESS,
  };
}

export function fetchPermissionsFailure(error) {
  return {
    type: FETCH_PERMISSION_FAILURE,
    payload: error,
  };
}

export function setPermissions(token) {
  return (dispatch) => {
    dispatch(requestPermissions());
    return axios.get(
      PERMISSION_URL,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    )
      .then((response) => {
        dispatch(fetchPermissionsSuccess(response));

        if (isAFM) {
          if (checkPermission('view_belongwarehouse_All')) {
            localStorage.setItem('warehouseLocation', '');
          } else if (checkPermission('view_belongwarehouse_Beaverton')) {
            localStorage.setItem('warehouseLocation', 'Beaverton');
          } else if (checkPermission('view_belongwarehouse_Bellevue')) {
            localStorage.setItem('warehouseLocation', 'Bellevue');
          } else if (checkPermission('view_belongwarehouse_Seattle')) {
            localStorage.setItem('warehouseLocation', 'Seattle');
          } else {
            localStorage.setItem('warehouseLocation', 'none');
          }
        } else {
          localStorage.setItem('warehouseLocation', '');
        }

        const companyCode = localStorage.getItem('companyCode');
        if (companyCode == 'LAC') {
          browserHistory.push('/routing');
          return;
        }
        browserHistory.push('/dashboard');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(err.status == 400 && err.data) {
          alert(err.data);
        }
        dispatch(fetchPermissionsFailure(err));
      });
  };
}

export function signinUser({ username, password }) {
  return function (dispatch) {
    const querystring = require('querystring');
    axios.post(TRUCKXI_LOGIN_URL, querystring.stringify({
      username,
      password,
      grant_type: 'password',
      client_id: '67P7iQKIr5LmnYWjKgYr5gfnULpAeWI7BEuJnuDP',
      'Content-Type': 'application/x-www-form-urlencoded',
    }))
      .then((response) => {
        dispatch({ type: AUTH_USER, payload: response.data.access_token });
        // dispatch({ type: AUTH_USER_PERMISSIONS, payload: response.data.user_permissions });
        localStorage.setItem('token', response.data.access_token);
        localStorage.setItem('username', username);
        // localStorage.setItem('userType', response.data.user_type);
        // localStorage.setItem('userPermissions', response.data.user_permissions);
        //browserHistory.push('/dashboard');
        dispatch(setPermissions(response.data.access_token));
      })
      .catch((error) => {
        dispatch(authError('Bad Login Info'));
      });
  };
}

export function signupUser({ username, password }) {
  return function (dispatch) {
    axios.post(`${ROOT_URL}/signup`, { username, password })
      .then((response) => {
        dispatch({ type: AUTH_USER });
        localStorage.setItem('token', response.data.token);
        browserHistory.push('/users');
      })
      .catch(() => {
        dispatch(authError('Bad Signup Info'));
      });
  };
}

export function authError(error) {
  return {
    type: AUTH_ERROR,
    payload: error,
  };
}


// If user logged out, redirect him to the home page, reset the state
// and remove the token.

export function signoutUser() {
  return function (dispatch) {
    dispatch({ type: UNAUTH_USER });
    localStorage.removeItem('token');
    browserHistory.push('/');
  };
}

export function checkStatues() {
  return (dispatch) => {
    if (localStorage.getItem('token')) {
      dispatch({ type: REQUEST_AUTH });
      return axios.get(TRUCKXI_TEST_URL, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
        .then(authUser(dispatch),
          // (dispatch) => {
          // dispatch({ type: AUTH_USER, payload: localStorage.getItem('userType')})
          // dispatch({ type: AUTH_USER_PERMISSIONS, payload: localStorage.getItem('userPermissions') });
          // }
        )
        .catch((error) => {
          dispatch({ type: UNAUTH_USER });
          if(error.status==401){
            alert("You have been logged out because you signed in on another device.");
          }
          browserHistory.push('/login');
        });
    }
    browserHistory.push('/login');
  };
}

export function authUser(dispatch) {
  dispatch({ type: AUTH_USER, payload: localStorage.getItem('userType') });
  dispatch({ type: AUTH_USER_PERMISSIONS, payload: localStorage.getItem('userPermissions') });
}



// WEBPACK FOOTER //
// ./master/jsx/actions/auth_actions.js